import React from 'react';

const NoPage = () => <h1 className='no-page-container'>Oops! Page not found.</h1>

export default NoPage;
